import _slicedToArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { deepMix } from '@antv/util';
/**
 * Mark functional attribute constant.
 */
export var MaybeFunctionAttribute = function MaybeFunctionAttribute() {
  return function (I, mark) {
    var _mark$style = mark.style,
      style = _mark$style === void 0 ? {} : _mark$style;
    return [I, deepMix({}, mark, {
      style: Object.assign(Object.assign({}, style), Object.fromEntries(Object.entries(style).filter(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          v = _ref2[1];
        return typeof v === 'function';
      }).map(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
          k = _ref4[0],
          v = _ref4[1];
        return [k, function () {
          return v;
        }];
      })))
    })];
  };
};
MaybeFunctionAttribute.props = {};